var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepThreeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12035_24814)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7453 16.072C11.1373 16.072 10.5613 15.976 10.0173 15.784C9.48128 15.584 9.04928 15.32 8.72128 14.992L9.14128 14.308C9.41328 14.588 9.77728 14.82 10.2333 15.004C10.6973 15.188 11.2013 15.28 11.7453 15.28C12.4413 15.28 12.9733 15.128 13.3413 14.824C13.7173 14.52 13.9053 14.112 13.9053 13.6C13.9053 13.088 13.7213 12.68 13.3533 12.376C12.9933 12.072 12.4213 11.92 11.6373 11.92H11.0373V11.284L13.6293 8.032L13.7493 8.368H9.06928V7.6H14.4693V8.212L11.8773 11.464L11.4573 11.188H11.7813C12.7893 11.188 13.5413 11.412 14.0373 11.86C14.5413 12.308 14.7933 12.884 14.7933 13.588C14.7933 14.06 14.6813 14.484 14.4573 14.86C14.2333 15.236 13.8933 15.532 13.4373 15.748C12.9893 15.964 12.4253 16.072 11.7453 16.072Z",
    fill: "#4C5862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12035_24814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepThreeIcon);
export default __webpack_public_path__ + "static/media/stepThreeIcon.7e9200d13d27cd43f9fd18e5190211ef.svg";
export { ForwardRef as ReactComponent };